
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaSkipPreviousGoogleF as ObiMediaSkipPreviousGoogleFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-skip-previous-google-f.js';
 
 
 

 
 export const ObiMediaSkipPreviousGoogleF = createComponent({
   react: React,
   tagName: 'obi-media-skip-previous-google-f',
   elementClass: ObiMediaSkipPreviousGoogleFElement,
   events: {
     
   }
  });
 
 